var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-2 mt-3"},[(_vm.status)?_c('b-skeleton-img'):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }